import React from "react";
import Increment from "./helper_components/Increment";
import CostListComponents from "./helper_components/CostListComponents";
import CostPhotoListComponent from "./helper_components/CostPhotoListComponent";
import menu from "../conf/menu";
import { Modal, Button, PanelGroup, Panel } from "react-bootstrap";
import moment from "moment";
import PaginationComponent from "./helper_components/PaginationComponent";
import CurrencyInput from "react-currency-input";
import { initialize } from "../utils/i18Util";
import {
  pdfDownload,
  fetchCostList
} from '../redux/actions/cost'
import CostImagePopup from "./helper_components/CostImagePopup";
import words from "../conf/words";
import { checkTokenUtil, mapForObject, onChangeDate } from "../utils";

class CostComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisibleModalSumiagro: false,
      isVisibleModal: false,
      detail: {},
      startPageNumber: 0,
      endPageNumber: 5,
      pageNumberToShow: 5,
      activePage: 1,
      numberOfPage: 10,
      revisionsModal: false,
      transactionModal: false,
      translatedCostTypes:[],
      translatedPaymentTypes:[],
      img: {
        show: false,
        src: ""
      },
      costBrandShow: []
    };
    this.setFieldForCostPhotos = this.setFieldForCostPhotos.bind(this)
    this.editCost = this.editCost.bind(this)
    this.closeAction = this.closeAction.bind(this)
    this.costUpdateButton = this.costUpdateButton.bind(this)
    this.costPhotoDeleteButtonAction = this.costPhotoDeleteButtonAction.bind(this)
    this.costDeleteButton = this.costDeleteButton.bind(this)
    this.costSendToApproval = this.costSendToApproval.bind(this)
    this.pdfDownloadButton = this.pdfDownloadButton.bind(this)
    this.pagination = this.pagination.bind(this)
    this.costImagePopupShow = this.costImagePopupShow.bind(this)
    this.filterCosts = this.filterCosts.bind(this)
    this.changeFormType = this.changeFormType.bind(this)

  }

  async componentDidMount() {
    await this.props.fetchCostList(
      this.refs.month.value,
      this.refs.year.value,
      this.refs.costFilterStatus.value,
      this.props.accessToken);
  }
  componentDidUpdate(prevProps, prevState) {
    const result = checkTokenUtil()
  }
  editCost(costData) {
    this.formType = costData.formType;
    costData.deletedPhotoId = false;
    if(costData.formType === "applicationSumiagro" || costData.formType === "settlementSumiagro" ) {
      this.setState({
        isVisibleModalSumiagro: true,
        detail: costData
      });
    }else {
      this.setState({
        isVisibleModal: true,
        detail: costData
      },async () => {
        const { translatedCostTypes, translatedPaymentTypes } = await initialize();
        this.setState({
          translatedCostTypes: translatedCostTypes,
          translatedPaymentTypes: translatedPaymentTypes
        });
      });
    }
    if (costData.costCategory && costData.costCategory != 'Genel Gider') {
      this.setState({
        costBrandShow: true
      })
    } else {
      this.setState({
        costBrandShow: false,
      },async () => {
        const { translatedCostTypes, translatedPaymentTypes } = await initialize();
        this.setState({
          translatedCostTypes: translatedCostTypes,
          translatedPaymentTypes: translatedPaymentTypes
        });
      });
    }
  }
  changeFormType(formType){
    this.setState({
      detail:{...this.state.detail, formType}
    })
    this.formType = formType
  }
  closeRevisionsModal(){
    const formType = this.state.detail.formType;
    if(formType === "applicationSumiagro" || formType === "settlementSumiagro"){
      this.setState({
        revisionsModal:false,
        isVisibleModalSumiagro:true
      })
    }else{
      this.setState({
        revisionsModal:false,
        isVisibleModal:true
      })
    }
  }
  async closeAction() {
    this.setState({
      isVisibleModal: false,
      isVisibleModalSumiagro: false
    });
    await this.props.fetchCostList(
      this.refs.month.value,
      this.refs.year.value,
      this.refs.costFilterStatus.value,
      this.props.accessToken);
  }
  costUpdateButton() {
    const { costUpdateFormValidation, accessToken, employeeInfo } = this.props;
    costUpdateFormValidation([this], accessToken, this.closeAction, employeeInfo);
  }
  costPhotoDeleteButtonAction(costId) {
    var { costPhotoDeleteButton, accessToken } = this.props;
    //costPhotoDeleteButton(costId, accessToken);
    // costPhotos.length > 0

    // fotoğraf yok, foto ekledim, tekrardan silmeye tıkladım
    // olmayan fotonun cost ıdsini aldım
     this.setState({
      detail: {...this.state.detail,
      costPhotos: [],
      deletedPhotoId: costId
      }
    })
  }
  costDeleteButton(costId) {
    this.props.costDeleteButtonAction(costId, this.props.accessToken, this.closeAction);
  }
  costSendToApproval(costData, costGroup = false) {
    this.props.costSendToApprovalAction(costData.costId, this.props.accessToken, costGroup);
  }
  async pdfDownloadButton(costData) {
    let costs = [];

    if (costData) {
      if(this.props.employeeInfo.masrafYoneticiOnayiBeklemedenPdfIndirebilsinMi == "true" && costData.firstCost.status == "manager"){
        if (costData.firstCost) {
          costs.push(costData.firstCost.costId)
        }
        if (costData.subCost && costData.subCost.length > 0) {
          for (let i = 0; i < costData.subCost.length; i++) {
            costs.push(costData.subCost[i].costId)
          }
        }
      } else{
        if (costData.firstCost && costData.firstCost.status == "accounting" || costData.firstCost.status == "completed") {
          costs.push(costData.firstCost.costId)
        }
        if(costData.subCost && costData.subCost.length > 0){
          for (let i = 0; i < costData.subCost.length; i++) {
            let status = costData.subCost[i].status;
             if(status == "accounting" || status == "completed"){
              costs.push(costData.subCost[i].costId)
            }
          }
        }
      }
    }

   await this.props.pdfDownload(this.props.employeeName, costs, this.props.accessToken, this.props.employeeInfo.language);
  }
  pagination() {
    var { activePage, numberOfPage } = this.state;
    var { costGroupList } = this.props;
    var pageIndex = (activePage * numberOfPage) - numberOfPage;
    var pageTotal = costGroupList.length - (activePage * numberOfPage);
    if (pageTotal < 0) {
      pageTotal = costGroupList.length;
    } else {
      pageTotal = pageIndex + numberOfPage;
    }
    return {
      totalPage: Math.ceil(costGroupList.length / numberOfPage),
      start: pageIndex,
      finish: pageTotal
    }
  }
  costImagePopupShow(src) {
    this.setState({
      img: {
        show: true,
        src: src
      }
    })
  }
  setFieldForCostPhotos() {
    let photo = document.querySelectorAll(".costPhoto")
    this.setState({
      costPhotos: photo
    })
  }

  async filterCosts(filter) {
    await this.props.fetchCostList(filter.month, filter.year, filter.status, this.props.accessToken)
  }
  handleOnChange = (event) => {
    if (event.target.value != 'Genel Gider') {
      this.setState({ costBrandShow: true });
    } else {
      this.setState({ costBrandShow: false });
    }
  };
  render() {

    const { costTypeList, costGroupList, maxCostTime, kdvOraniList, employeeInfo, kdvOraniAktif, t } = this.props;
    document.title = t(menu[this.props.location.pathname]) + " - masraf.dakika.com.tr";
    let { costAmount, costDate, costCancelDescription, costDescription, costId, costType, invoiceNo, kdvOrani, moneyType, paymentType, status, supplierName, costPhotos, revisions, transactions, cancellationRequest, costLocation, costCategory, costBrand, formType, companyName, placeName, guestName, guestNumber, otherParticipant, otherParticipantNumber, staffName, staffNumber, preApprovedBudget } = this.state.detail;
    costPhotos = (costPhotos ? costPhotos : [0]);
    let checkCostPhotosInstance = costPhotos instanceof NodeList;
    let year = [];
    let { totalPage, start, finish } = this.pagination();
    var getAllMoney = new window.Money().getAllMoney();
    var getAllMoneyI18nCodes= new window.Money().getAllMoneyI18nCodes()
    for (let i = window.costStartingYear; i <= new Date().getFullYear(); i++) {
      year.push(<option key={i} value={i}>{i}</option>);
    }
    if (!revisions)
      revisions = [];
    return (
      <div className="content">
        {
          /*
            Cost Image Popup
          */
        }
        <CostImagePopup t={t} closeButton={() => {
          this.setState({
            img: {
              show: false,
              src: ""
            }
          })
        }} show={this.state.img.show} src={this.state.img.src} />
        {
          /*
            Masraf detay MODAL
          */
        }
            <Modal show={this.state.isVisibleModalSumiagro}>
          <Modal.Header closeButton onHide={this.closeAction}>
            <Modal.Title id="contained-modal-title">{t("costDetail")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover table-bordered">
              <tbody>
              <tr>
                <td>{t("costFormType")}</td>
                <td>
                  <select
                      className="form-control border-input"
                      defaultValue={formType}
                      onChange={(e) => this.changeFormType(e.target.value)}
                  >
                    <option value="applicationSumiagro">Application</option>
                    <option value="settlementSumiagro">Settlement</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>{t("costDate")}</td>
                <td><input type="date" disabled onBlur={(e) => {
                  onChangeDate(e, maxCostTime);
                }} ref="costDate" defaultValue={costDate ? moment(costDate, "DD/MM/Y").format("Y-MM-DD") : null}
                           className="col-xs-12"/></td>
              </tr>
              <tr>
                <td>{t("invoiceNo")}</td>
                <td><input type="text" ref="invoiceNo" defaultValue={invoiceNo} className="col-xs-12"/></td>
              </tr>
              <tr>
                <td>{t("costType")}</td>
                <td><select defaultValue={costType} ref="costType" className="col-xs-12">
                  {
                    costTypeList.map((data, key) => {
                      return (
                          <option value={data.type} key={key}>{data.type}</option>
                      );
                    })
                  }
                </select></td>
              </tr>
              {
                formType === "settlementSumiagro" ? (
                    <>
                      <tr>
                        <td>{t("preApprovedBudget")}</td>
                        <td>
                          <CurrencyInput
                              className="form-control border-input"
                              value={preApprovedBudget}
                              placeholder={t("preApprovedBudget")}
                              ref="preApprovedBudget"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>{t("actualExpenditure")}</td>
                        <td>
                          <CurrencyInput
                              className="form-control border-input"
                              value={costAmount}
                              placeholder={t("actualExpenditure")}
                              ref="costAmount"
                          />
                        </td>
                      </tr>
                    </>
                ) : (
                    <tr>
                      <td>{t("costAmount")}</td>
                      <td>
                        <CurrencyInput
                            className="form-control border-input"
                            value={costAmount}
                            placeholder={t("costAmount")}
                            ref="costAmount"
                        />
                      </td>
                    </tr>
                )
              }
              <tr>
                <td>{t("company")}</td>
                <td><input type="text" ref="companyName" defaultValue={companyName} className="col-xs-12"/></td>
              </tr>
              <tr>
                <td>{t("place")}</td>
                <td><input type="text" ref="placeName" defaultValue={placeName} className="col-xs-12"/></td>
              </tr>
              <tr>
                <td>{t("guests")}</td>
                <td><input type="text" ref="guestName" defaultValue={guestName} className="col-xs-12"/></td>
              </tr>
              <tr>
                <td>{t("guestNumber")}</td>
                <td><input type="text" ref="guestNumber" defaultValue={guestNumber} className="col-xs-12"/></td>
              </tr>
              <tr>
                <td>{t("staff")}</td>
                <td><input type="text" ref="staffName" defaultValue={staffName} className="col-xs-12"/></td>
              </tr>
              <tr>
                <td>{t("staffNumber")}</td>
                <td><input type="text" ref="staffNumber" defaultValue={staffNumber} className="col-xs-12"/></td>
              </tr>
              <tr>
                <td>{t("otherParticipants")}</td>
                <td><input type="text" ref="otherParticipant" defaultValue={otherParticipant} className="col-xs-12"/>
                </td>
              </tr>
              <tr>
                <td>{t("otherParticipantNumber")}</td>
                <td><input type="text" ref="otherParticipantNumber" defaultValue={otherParticipantNumber}
                           className="col-xs-12"/></td>

              </tr>
              <tr>
                <td>{t('currencyUnit')}</td>
                <td><select defaultValue={moneyType} ref="moneyType" className="col-xs-12">
                  {
                      employeeInfo.costMoneyType && employeeInfo.costMoneyType.map((data, key) => {
                        return (
                            <option
                                key={key}
                                value={data.type}>({getAllMoney[data.type]}) {t(getAllMoneyI18nCodes[data.type])}</option>
                        );
                      })
                  }
                </select></td>
              </tr>
              <tr>
                <td>{t("paymentType")}</td>
                <td><select defaultValue={paymentType} ref="paymentType" className="col-xs-12">
                  {
                      employeeInfo.paymentType && employeeInfo.paymentType.map((data, key) => {
                        return (
                            <option value={data.type} key={key}>{data.type}</option>
                        );
                      })
                  }
                </select></td>
              </tr>
              {
                employeeInfo.costCategory && employeeInfo.costCategory.length > 0
                    ?
                    <tr>
                      <td>{t("costCategory")}</td>
                      <td><select defaultValue={costCategory} ref="costCategory" className="col-xs-12"
                                  onChange={this.handleOnChange}>
                        {
                          employeeInfo.costCategory.map((data, key) => {
                            return (
                                <option value={data.type} key={key}>{data.type}</option>
                            );
                          })
                        }
                      </select></td>
                    </tr>
                    : null
              }
              {
                employeeInfo.costBrand && employeeInfo.costBrand.length > 0 && this.state.costBrandShow
                    ?
                    <tr>
                      <td>{t("costBrand")}</td>
                      <td><select defaultValue={costBrand} ref="costBrand" className="col-xs-12">
                        {
                          employeeInfo.costBrand.map((data, key) => {
                            return (
                                <option value={data.type} key={key}>{data.type}</option>
                            );
                          })
                        }
                      </select></td>
                    </tr>
                    : null
              }
              {
                employeeInfo.costLocation && employeeInfo.costLocation.length > 0
                    ?
                    <tr>
                      <td>{t("costKind")}</td>
                      <td><select defaultValue={costLocation} ref="costLocation" className="col-xs-12">
                        {
                          employeeInfo.costLocation.map((data, key) => {
                            return (
                                <option value={data.type} key={key}>{data.type}</option>
                            );
                          })
                        }
                      </select></td>
                    </tr>
                    : null
              }
              {
                kdvOraniList && kdvOraniList.length > 0
                    ?
                    <tr>
                      <td>{t("vatRate")}</td>
                      <td><select defaultValue={kdvOrani} ref="kdvOrani" className="col-xs-12">
                        {
                          kdvOraniList.map((data, key) => {
                            return (
                                <option value={data.type} key={key}>{data.type}</option>
                            );
                          })
                        }
                      </select></td>
                    </tr>
                    : null
              }
              <tr>
                <td>{t("supplierName")}</td>
                <td><input type="text" ref="supplierName" defaultValue={supplierName} className="col-xs-12"/></td>
              </tr>
              <tr>
                <td>{t("description")}</td>
                <td><textarea ref="costDescription" defaultValue={costDescription}
                              className="col-xs-12 resize-no"></textarea></td>
              </tr>
              <tr>
                <td>{t("photos")}:</td>
                <td>
                  <div className="row">
                    {
                      costPhotos.length > 0 && !checkCostPhotosInstance
                          ?
                          costPhotos.map((d, k) => {
                            return <CostPhotoListComponent t={t} costImagePopupShow={(src) => {
                              this.costImagePopupShow(src)
                            }} photo={d} photoDelete="true" costPhotoDeleteButton={this.costPhotoDeleteButtonAction}
                                                           key={k}/>
                          })
                          :
                          //<h6 className="title" style={{paddingLeft:"10px"}}>Fotoğraf yüklenmemiş.</h6>
                          <Increment t={t} costNumber={1} setCostPhoto={this.setFieldForCostPhotos}
                                     style="margin-left: 0px"/>


                    }
                  </div>

                </td>
              </tr>
              <tr>
                <td>{t("isPublicServant")}</td>
                <td>
                  <select
                      className="form-control border-input"
                      defaultValue=""
                      ref="isPublicServant"
                  >
                    <option value="-1">{t("yesOrNo")}</option>
                    <option value="Evet">Evet</option>
                    <option value="Hayır">Hayır</option>
                  </select>
                </td>
              </tr>
              {
                status == "cancel" || status == "accountingCancel"
                    ?
                    <tr>
                      <td>{t("reasonForCancellation")}:</td>
                      <td><span className="cancelText">{costCancelDescription}</span></td>
                    </tr>
                    :
                    null
              }
              </tbody>
            </table>
          </Modal.Body>
              <Modal.Footer>
                <div className="row">
                  <div className="col-md-2">
                    <Button className="btn btn-warning btn-fill btn-wd" onClick={() => {
                      this.setState({
                        revisionsModal: true,
                        isVisibleModalSumiagro: false
                      })
                    }}>{t("revisions")}</Button>
                  </div>
              {
                (status == "accounting" || status == "manager" || status == "waiting" || status == "accountingCancel" || status == "cancel") && (this.props.filter.status == "waiting" || !cancellationRequest || !cancellationRequest.now)
                  ?
                  <div className="col-md-10">
                    <Button className="btn btn-wd btn-success" onClick={() => { this.costUpdateButton() }}><span className="btn-label"><i className="fa fa-check"></i></span> {t('update')}</Button>
                    <Button className="btn btn-wd btn-danger" onClick={() => { this.costDeleteButton(costId) }}><span className="btn-label"><i className="fa fa-times"></i></span>{t('removeCost')}</Button>
                  </div>
                  :
                  null
              }
            </div>
            <input type="hidden" ref="costId" defaultValue={costId} />
            <input type="hidden" ref="status" defaultValue={status} />
          </Modal.Footer>
        </Modal>
        {     /*
            Masraf Güncelleme MODAL
          */}
        <Modal show={this.state.isVisibleModal}>
          <Modal.Header closeButton onHide={this.closeAction}>
            <Modal.Title id="contained-modal-title">{t('costDetail')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover table-bordered">
              <tbody>
                <tr>
                  <td>{t('costDate')}</td>
                  <td><input type="date" disabled onBlur={(e) => {
                    onChangeDate(e, maxCostTime);
                  }} ref="costDate" defaultValue={costDate ? moment(costDate, "DD/MM/Y").format("Y-MM-DD") : null} className="col-xs-12" /></td>
                </tr>
                <tr>
                  <td>{t('invoiceNo')}</td>
                  <td><input type="text" ref="invoiceNo" defaultValue={invoiceNo} className="col-xs-12" /></td>
                </tr>
                <tr>
                  <td>{t('costType')}</td>
                  <td><select defaultValue={costType} ref="costType" className="col-xs-12">
                    { employeeInfo.language === "tr" ?
                        costTypeList.map((data, key) => {
                          return <option value={data.type} key={key}>{data.type}</option>
                        }):
                        this.state.translatedCostTypes.map((data, key) => {
                          return <option value={data.type} key={key}>{data.type}</option>
                        })
                    }
                  </select></td>
                </tr>
                <tr>
                  <td>{t('costAmount')}</td>
                  <td><CurrencyInput className="form-control border-input" value={costAmount} placeholder={t('costAmount')} ref="costAmount" /></td>
                </tr>
                <tr>
                  <td>{t('currencyUnit')}</td>
                  <td><select defaultValue={moneyType} ref="moneyType" className="col-xs-12">
                    {
                      employeeInfo.costMoneyType && employeeInfo.costMoneyType.map((data, key) => {
                        return (
                          <option key={key} value={data.type}>({getAllMoney[data.type]}) {t(getAllMoneyI18nCodes[data.type])}</option>
                        );
                      })
                    }
                  </select></td>
                </tr>
                <tr>
                  <td>{t('paymentType')}</td>
                  <td><select defaultValue={paymentType} ref="paymentType" className="col-xs-12">
                    {  employeeInfo.language === "tr" ?
                        employeeInfo.paymentType && employeeInfo.paymentType.map((data, key) => {
                          return <option value={data.type} key={key}>{data.type}</option>
                        }):
                        this.state.translatedPaymentTypes.map((data, key) => {
                          return <option value={data.type} key={key}>{data.type}</option>
                        })
                    }
                  </select></td>
                </tr>
                {
                  employeeInfo.costCategory && employeeInfo.costCategory.length > 0
                    ?
                    <tr>
                      <td>{t('costCategory')}</td>
                      <td><select defaultValue={costCategory} ref="costCategory" className="col-xs-12" onChange={this.handleOnChange}>
                        {
                          employeeInfo.costCategory.map((data, key) => {
                            return (
                              <option value={data.type} key={key}>{data.type}</option>
                            );
                          })
                        }
                      </select></td>
                    </tr>
                    : null
                }
                {
                  employeeInfo.costBrand && employeeInfo.costBrand.length > 0 && this.state.costBrandShow
                    ?
                    <tr>
                      <td>{t('costBrand')}</td>
                      <td><select defaultValue={costBrand} ref="costBrand" className="col-xs-12">
                        {
                          employeeInfo.costBrand.map((data, key) => {
                            return (
                              <option value={data.type} key={key}>{data.type}</option>
                            );
                          })
                        }
                      </select></td>
                    </tr>
                    : null
                }
                {
                  employeeInfo.costLocation && employeeInfo.costLocation.length > 0
                    ?
                    <tr>
                      <td>{t('costKind')}</td>
                      <td><select defaultValue={costLocation} ref="costLocation" className="col-xs-12">
                        {
                          employeeInfo.costLocation.map((data, key) => {
                            return (
                              <option value={data.type} key={key}>{data.type}</option>
                            );
                          })
                        }
                      </select></td>
                    </tr>
                    : null
                }
                {
                  kdvOraniList && kdvOraniList.length > 0
                    ?
                    <tr>
                      <td>{t('vatRate')}</td>
                      <td><select defaultValue={kdvOrani} ref="kdvOrani" className="col-xs-12">
                        {
                          kdvOraniList.map((data, key) => {
                            return (
                              <option value={data.type} key={key}>{data.type}</option>
                            );
                          })
                        }
                      </select></td>
                    </tr>
                    : null
                }
                <tr>
                  <td>{t('supplierName')}</td>
                  <td><input type="text" ref="supplierName" defaultValue={supplierName} className="col-xs-12" /></td>
                </tr>
                <tr>
                  <td>{t('description')}</td>
                  <td><textarea ref="costDescription" defaultValue={costDescription} className="col-xs-12 resize-no"></textarea></td>
                </tr>
                <tr>
                  <td>{t('photos')}: </td>
                  <td>
                    <div className="row">
                      {
                        costPhotos.length > 0 && !checkCostPhotosInstance
                          ?
                          costPhotos.map((d, k) => {
                            return <CostPhotoListComponent  t={t} costImagePopupShow={(src) => { this.costImagePopupShow(src) }} photo={d} photoDelete="true" costPhotoDeleteButton={this.costPhotoDeleteButtonAction} key={k} />
                          })
                          :
                          //<h6 className="title" style={{paddingLeft:"10px"}}>Fotoğraf yüklenmemiş.</h6>
                          <Increment t={t} costNumber={1} setCostPhoto={this.setFieldForCostPhotos} style="margin-left: 0px" />
                      }
                    </div>
                  </td>
                </tr>
                {
                  status == "cancel" || status == "accountingCancel"
                    ?
                    <tr>
                      <td>{t('reasonForCancellation')}: </td>
                      <td><span className="cancelText">{costCancelDescription}</span></td>
                    </tr>
                    :
                    null
                }
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-md-2">
                <Button className="btn btn-warning btn-fill btn-wd" onClick={() => {
                  this.setState({
                    revisionsModal: true,
                    isVisibleModal: false
                  })
                }}>{t('revisions')}</Button>
              </div>
              {
                (status == "accounting" || status == "manager" || status == "waiting" || status == "accountingCancel" || status == "cancel") && (this.props.filter.status == "waiting" || !cancellationRequest || !cancellationRequest.now)
                  ?
                  <div className="col-md-10">
                    <Button className="btn btn-wd btn-success" onClick={() => { this.costUpdateButton() }}><span className="btn-label"><i className="fa fa-check"></i></span>{t('update')}</Button>
                    <Button className="btn btn-wd btn-danger" onClick={() => { this.costDeleteButton(costId) }}><span className="btn-label"><i className="fa fa-times"></i></span>{t('removeCost')}</Button>
                  </div>
                  :
                  null
              }
            </div>
            <input type="hidden" ref="costId" defaultValue={costId} />
            <input type="hidden" ref="status" defaultValue={status} />
          </Modal.Footer>
        </Modal>
        {
          /*
            Revize Modal
          */
        }
        <Modal show={this.state.revisionsModal}>
          <Modal.Header closeButton onHide={() => {
            this.setState({
              revisionsModal: false
            })
          }}>
            <Modal.Title id="contained-modal-title">{t('revisions')} / <span className="costForUsername" dangerouslySetInnerHTML={{__html: t('totalRevision',{length: revisions ? revisions.length : null})}}></span></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <PanelGroup>
              {
                revisions.length > 0
                  ?
                  revisions.map((fields, key) => {
                    return (
                      <Panel key={key} collapsible header={fields.date} eventKey={key}>
                        <table className="table table-hover table-bordered">
                          <tbody>
                            {
                              fields.fields
                                ?
                                mapForObject(fields.fields, (data, index, key2) => {
                                  var nextData = [];
                                  var incrementKey = key + 1;
                                  while (incrementKey < revisions.length) {
                                    nextData = mapForObject(revisions[incrementKey].fields, index);
                                    if (typeof nextData != "object")
                                      break;
                                    incrementKey++;
                                  }
                                  if (typeof nextData === "object")
                                    nextData = this.state.detail[index];
                                  return (
                                    <tr key={key2}>
                                      <td>{t(words.costFields[index])}</td>
                                      <td><strong className="darkred">{data}</strong> / <strong className="green">{nextData}</strong></td>
                                    </tr>
                                  )
                                })
                                :
                                <tr>
                                  <td>{t('notUpdatedData')}</td>
                                </tr>
                            }
                          </tbody>
                        </table>
                      </Panel>

                    )
                  })
                  :
                  null
              }
            </PanelGroup>
          </Modal.Body>
          <Modal.Footer style={{ textAlign: "left" }}>
            <button type="button" onClick={() => this.closeRevisionsModal()} className="btn btn-wd btn-default"><span className="btn-label"><i className="fa fa-arrow-left"></i></span>{t('back')}</button>
          </Modal.Footer>
        </Modal>
        {
          /*
            İşlem Modal
          */
        }
        <Modal show={this.state.transactionModal}>
          <Modal.Header closeButton onHide={() => {
            this.setState({
              transactionModal: false
            })
          }}>
            <Modal.Title id="contained-modal-title">{t('transactions')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <PanelGroup>
              {
                transactions
                  ?
                  transactions.map((fields, key) => {
                    return (
                      <Panel style={{padding: "10px 10px 0px 10px"}} key={key} collapsible header={fields.transactionDate + " - " + fields.employeeName} eventKey={key}>
                        <p className="p">
                          <strong className="employeeName">{fields.employeeName }, </strong>
                          <span dangerouslySetInnerHTML={{
                          __html: t('approvedRejectedDate',
                          {
                            date:fields.transactionDate,
                            time:fields.transactionTime,
                            transactionType: fields.transactionType == 1 ? t('approvedTransactions') : t('rejectedTransactions')
                          })}}></span>
                        {
                            fields.transactionType == 2
                              ?
                              <div style={{ marginTop: "10px" }}>
                                <Panel collapsible header={t('reasonOfTheRejected')} style={{padding: "10px 10px 0px 10px"}}>
                                  <p className="p">
                                    {costCancelDescription}
                                  </p>
                                </Panel>
                              </div>
                              :
                              null
                          }
                        </p>
                      </Panel>
                    )
                  })
                  :
                  null
              }
            </PanelGroup>
          </Modal.Body>
        </Modal>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12">
              <div className="card">
                <div className="content">
                  <div className="row">
                    <div className="col-md-3">
                      <select defaultValue={this.props.filter.status} id="costFilterStatus" ref="costFilterStatus" onChange={(comp) => {
                        this.filterCosts({
                          month: this.refs.month.value,
                          year: this.refs.year.value,
                          status: comp.target.value
                        });
                        this.setState({
                          activePage: 1
                        });
                      }} className="form-control input-sm border-input filterSelect">
                        <option value="manager">{t('awaitingApproval')}</option>
                        <option value="waiting">{t('expensesPendingSubmission')}</option>
                        <option value="completed">{t('approvedCosts')}</option>
                        <option value="cancel">{t('rejects')}</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <select ref="month" id="costFilterMonth" defaultValue={this.props.filter.month} className="form-control input-sm border-input filterSelect" onChange={(comp) => {
                        this.filterCosts({
                          month: comp.target.value,
                          year: this.refs.year.value,
                          status: this.refs.costFilterStatus.value
                        });
                        this.setState({
                          activePage: 1
                        });
                      }}>
                        <option value="-1">{t('selectMonth')}</option>
                        <option value="01">{t('jan')}</option>
                        <option value="02">{t('feb')}</option>
                        <option value="03">{t('mar')}</option>
                        <option value="04">{t('apr')}</option>
                        <option value="05">{t('may')}</option>
                        <option value="06">{t('jun')}</option>
                        <option value="07">{t('jul')}</option>
                        <option value="08">{t('aug')}</option>
                        <option value="09">{t('sep')}</option>
                        <option value="10">{t('oct')}</option>
                        <option value="11">{t('nov')}</option>
                        <option value="12">{t('dec')}</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <select ref="year" id="costFilterYear" defaultValue={new Date().getFullYear()} className="form-control input-sm border-input filterSelect" onChange={(comp) => {
                        this.filterCosts({
                          month: this.refs.month.value,
                          year: comp.target.value,
                          status: this.refs.costFilterStatus.value
                        });
                        this.setState({
                          activePage: 1
                        });
                      }}>
                        <option value="-1">{t('selectYear')}</option>
                        {year}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <div className="card">
                <div className="header">
                  <h4 className="title">{t('expenses')}</h4>
                </div>
                <div className="content">
                  <div className="content table-responsive table-full-width">
                    <div className="div-table">
                      {

                      }
                      <div className="div-table-header">
                        <div className="row">
                          <div className="col-md-1">

                          </div>
                          <div className="col-md-1">
                            <h5>{t('invoice')}</h5>
                          </div>
                          <div className="col-md-2">
                            <h5>{t('costType')}</h5>
                          </div>
                          <div className="col-md-2">
                            <h5>{t('costDate')}</h5>
                          </div>
                          <div className="col-md-1">
                            <h5>{t('amount')}</h5>
                          </div>
                          <div className="col-md-2">
                            <h5>{t('status')}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="div-table-content" id="employeeCostList">
                        {
                          costGroupList.length > 0
                            ?
                            costGroupList.slice(start, finish).map((costGroupList, key) => {
                              return <CostListComponents
                                t={t}
                                key={costGroupList.groupId}
                                employeeInfo={this.props.employeeInfo}
                                group={costGroupList}
                                transactionsButton={(data) => { this.setState({ transactionModal: true, detail: data }) }}
                                editCost={(data) => { this.editCost(data) }}
                                deleteCostAction={(costId) => { this.costDeleteButton(costId) }}
                                pdfDownloadButton={(data) => { this.pdfDownloadButton(costGroupList) }}
                                costSendToApproval={(data, costGroup) => { this.costSendToApproval(data, costGroup) }} />
                            })
                            :
                            null
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            costGroupList.length > 0 ?
              <div className="card">
                <div className="content">
                  <PaginationComponent t={t} totalPage={totalPage} endPageNumber={this.state.endPageNumber} startPageNumber={this.state.startPageNumber} pageNumberToShow={this.state.pageNumberToShow} parent={this} activePage={this.state.activePage} numberOfPage={this.state.numberOfPage} data={costGroupList} />
                </div>
              </div>
              : null
          }
        </div>
      </div>
    );
  }
}

export default CostComponent;
